/* eslint-disable camelcase */
import { isNumber, slugify } from "src/utils/string";
import { generateLabelTextForSearchboxGTMEventE6t } from "src/helpers/google-tag-manager/common";

const locationTypes = {
  city: "il",
  district: "ilce",
  locality: "semt",
  town: "mahalle",
  poi: "yakininda-ara",
  project: "siteler",
  districts: "ilce",
  localities: "semt",
  towns: "mahalle",
  poies: "yakininda-ara",
  sites: "siteler",
};

const getLocationName = (location) => {
  const { districts, district, towns, town, city, localities, locality, poi, poies, poiSet, project, projects, sites } =
    location || {};

  if (sites?.length || project || projects) return locationTypes.sites;
  if (poies?.length || poiSet?.length || poi) return locationTypes.poies;
  if (towns?.length || town) return locationTypes.towns;
  if (localities?.length || locality) return locationTypes.localities;
  if (districts?.length || district) return locationTypes.districts;
  if (city?.name) return locationTypes.city;
  return null;
};

const getGa4SearchTypeParam = ({ criteriaState, activeTab, structuredValue }) => {
  const { location, freetext } = criteriaState || {};
  const tabName = slugify(activeTab);
  const searchIsWithListingId = isNumber(freetext?.value);
  const locationName = getLocationName(location);
  const freeTextValue = searchIsWithListingId ? "ilan-id" : "freetext";
  if (locationName) return `${tabName}||structured||${locationName}`;
  if (searchIsWithListingId) return `structured||${freeTextValue}`;
  if (structuredValue) return `structured||${tabName}`;
  return `${tabName}||${freeTextValue}`;
};

export const getGa4SearchEventParams = ({ btnCategory, criteriaState, activeTab, poies, structuredValue }) => {
  const freeText = poies?.length > 0 ? poies[0]?.name || "" : criteriaState?.freetext?.value || "";
  const searchLabel = criteriaState?.location
    ? generateLabelTextForSearchboxGTMEventE6t(criteriaState.location, freeText)
    : "";
  const searchGTMLabel = freeText || searchLabel;
  const search_term = searchGTMLabel ? slugify(searchGTMLabel) : "";
  const search_type = getGa4SearchTypeParam({ criteriaState, activeTab, structuredValue });
  const search_status = btnCategory === "haritada-ara" ? "map" : "default";
  return { search_term, search_type, search_status };
};
